module.exports = __webpack_public_path__ + "img/LOGO_WHITELABEL.f29b3ac7.svg";